import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const AuthIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9490" width="14" height="14">
      <defs>
        <style type="text/css" />
      </defs>
      <path
        d="M896.934552 148.18128a594.947839 594.947839 0 0 1-193.645991-41.490758A881.712294 881.712294 0 0 1 537.594948 18.590015l-25.594948-18.421627-25.594948 18.421627a881.712294 881.712294 0 0 1-165.693613 88.100507A612.089719 612.089719 0 0 1 127.065448 148.18128L84.631717 148.720121V579.254095c0 216.142603 277.503124 444.54384 427.031507 444.54384s427.031507-228.434914 427.705059-444.54384V148.551733zM480.679866 720.262054l-180.848517-154.68105 55.56798-65.536539 116.187595 98.809972 221.261593-253.996185 64.660922 56.342564z m0 0"
        p-id="9491"
      />
    </svg>
  </span>
);

export default AuthIcon;
